export * from './input-icon-button.module';
export * from './input-icon-button.component';
